import { useEffect, useState } from "react";
import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL || "";

export function galleryImageUrl(img) {
    if (!img || !img.url) return "";
    if (/^https?:\/\//.test(img.url)) return img.url;
    return `${BASE}${img.url}`;
}

export function useGalleryImages() {
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;
        axios
            .get(`${BASE}/api/gallery/images`)
            .then((res) => {
                if (!cancelled) setImages(Array.isArray(res.data) ? res.data : []);
            })
            .catch(() => {
                if (!cancelled) setImages([]);
            })
            .finally(() => {
                if (!cancelled) setLoading(false);
            });
        return () => {
            cancelled = true;
        };
    }, []);

    return { images, loading };
}
